const ProgressNumber = ({ number }) => {
  return (
    <div className='flex justify-center items-center font-display w-12 h-12 bg-primary-200 rounded-full'>
      <span className='text-primary-700 text-3xl not-italic font-semibold'>{number}</span>
    </div>
  )
}

export default ProgressNumber
